import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { FloatingActions } from "@/components/FloatingActions";
import { Contact } from "@/components/Contact";
import { ZoryvenHero } from "@/components/zoryven/ZoryvenHero";
import { BrandStory } from "@/components/zoryven/BrandStory";
import { ProductRange } from "@/components/zoryven/ProductRange";
import { Reviews } from "@/components/salon/Reviews";

export default function ZoryvenHome() {
  return (
    <div className="bg-[#030B08] text-slate-100 font-sans antialiased selection:bg-[#D48C46] selection:text-slate-950 min-h-screen" data-testid="zoryven-home-page">
      <SiteHeader brand="zoryven" />
      <ZoryvenHero />
      <BrandStory />
      <ProductRange />
      <Reviews tone="emerald" />
      <Contact tone="emerald" defaultService="Product Inquiry" />
      <SiteFooter brand="zoryven" />
      <FloatingActions />
    </div>
  );
}
